import map from "../../../assets/img/feature/map.svg";
import gun from "../../../assets/img/feature/gun.svg";
import health from "../../../assets/img/feature/health.svg";
import backpack from "../../../assets/img/feature/backpack.svg";
import tree from "../../../assets/img/feature/tree.svg";
import survive from "../../../assets/img/feature/survive.svg";
import skull from "../../../assets/img/feature/skull.svg";
import tent from "../../../assets/img/feature/tent.svg";

export default [
  {
    icon: map,
    text:
      "Explore a beautifully handcrafted, pixel-art-style open world map with signature buildings"
  },
  {
    icon: gun,
    text:
      "Gear up your character and try to survive for as long as possible using tons of loot"
  },
  {
    icon: health,
    text: "Watch your health, hunger and thirst levels, prevent blood loss"
  },
  {
    icon: backpack,
    text:
      "Keep on surviving to improve your character stats, receive perks and collect achievements for your efforts"
  },
  {
    icon: tree,
    text:
      "Grow plants, craft new items and build a makeshift base with campfire and fences"
  },
  {
    icon: survive,
    text:
      "Meet AI survivors, both friendly and hostile, and fight (or avoid) various kinds of dangerous, ever-lurking infected"
  },
  {
    icon: skull,
    text:
      "Make the wilderness your friend, not your enemy - use natural resources to stay alive"
  },
  {
    icon: tent,
    text:
      "Find your way during the day/night cycle and do your best to stay warm while it rains or snows"
  }
];
